(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["blog-grid-design-1"] && !window.DesignMode) return;
  try {
    
	function loadBlogSlider(evt) {
		var sectionContent = $("#" +evt.target.id + " .blog-grid-design-1-slider");
		if(sectionContent.length) {
			switch (evt.originalEvent.type) {
				case "shopify:section:load":
					sectionContent.owlCarousel({
						loop:false,
						margin: 30,
						nav:true,
						navText: ['<span class="pe-7s-angle-left"></span>','<span class="pe-7s-angle-right"></span>'],
						dots: false,
						responsive:{
							0:{
								items:1
							},
							600:{
								items:2
							},
							1000:{
								items:2
							}
						}
					});
				break;
			}
		}
	}
		
	$(document).on('shopify:section:load', loadBlogSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hot-deal"] && !window.DesignMode) return;
  try {
    
	function loadCountdown(evt) {
		var sectionContent = $("#" +evt.target.id + " .hot-deal");
		if(sectionContent.length) {
			switch (evt.originalEvent.type) {
				case "shopify:section:load":
					var year = sectionContent.find('.until-year').val();
					var month = sectionContent.find('.until-month').val();
					var day = sectionContent.find('.until-day').val();
					var newDate = new Date(year, month, day);
					sectionContent.find('.countdown').countdown({until: newDate});
				break;
			}
		}
	}
		
	$(document).on('shopify:section:load', loadCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-list"] && !window.DesignMode) return;
  try {
    
	function loadLogoListSlider(evt) {
		var sectionContent = $("#" +evt.target.id + " .logo-list-slider");
		if(sectionContent.length) {
			switch (evt.originalEvent.type) {
				case "shopify:section:load":
					sectionContent.owlCarousel({
						loop:true,
						margin:50,
						nav:false,
						dots:false,
						autoplay:true,
						autoplayTimeout:5000,
						autoplayHoverPause:true,
						responsive:{
							0:{
								items:1
							},
							600:{
								items:2
							},
							1000:{
								items:5
							}
						}
					});
				break;
			}
		}
	}
		
	$(document).on('shopify:section:load', loadLogoListSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tab"] && !window.DesignMode) return;
  try {
    
	function loadTab(evt) {
		var sectionContent = $("#" +evt.target.id + " .product-tabs");
		if(sectionContent.length) {
			switch (evt.originalEvent.type) {
				case "shopify:section:load": 
					$(".product-tabs").tabs();
					$('.product-slider-demo').owlCarousel({
				        loop:false,
				        margin:0,
				        nav:false,
				        responsive:{
				            0:{
				                items:1
				            },
				            600:{
				                items:2
				            },
				            1000:{
				                items:4
				            }
				        }
				    })
				break;
			}
		}
	}		
	$(document).on('shopify:section:load', loadTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider"] && !window.DesignMode) return;
  try {
    
	function loadSlider(evt) {
		var sectionContent = $("#" +evt.target.id + " .banner-slider");
		if(sectionContent.length) {
			switch (evt.originalEvent.type) {
				case "shopify:section:load": 
					$('.banner-slider').owlCarousel({
						loop: true,
						items:1,
	    				margin:0,
	    				nav: true,
	    				autoplay: true,
	    				autoplayTimeout: 3000,
	    				autoplayHoverPause: true,
	    				navText: ['<span class="pe-7s-angle-left"></span>','<span class="pe-7s-angle-right"></span>'],
	    				animateIn: 'fadeInRight',
	    				animateOut: 'fadeOutLeft'
					})
				break;
			}
		}
	}		
	$(document).on('shopify:section:load', loadSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-design-1"] && !window.DesignMode) return;
  try {
    
	function loadTestimonialSlider(evt) {
		var sectionContent = $("#" +evt.target.id + " .testimonial-design-1-slider");
		if(sectionContent.length) {
			switch (evt.originalEvent.type) {
				case "shopify:section:load":
					sectionContent.owlCarousel({
						loop:true,
						margin:0,
						nav:false,
						responsive:{
							0:{
								items:1
							},
							600:{
								items:1
							},
							1000:{
								items:1
							}
						}
					});
				break;
			}
		}
	}
		
	$(document).on('shopify:section:load', loadTestimonialSlider);

  } catch(e) { console.error(e); }
})();

})();
